import { isAxiosError } from "axios";

const errorMap = {
  500: "500",
  401: "400",
  10001: "10001",
  DEFAULT: "UKJENT",
} as const;
export type ErrorKey = keyof typeof errorMap;

type ErrorParams = {
  errorCode: string;
  status: number;
};

const defaultResponse = {
  errorCode: errorMap.DEFAULT,
  status: 500,
} satisfies ErrorParams;

export function getAuthErrorMessage(error: unknown): ErrorParams {
  if (!isAxiosError(error)) {
    return defaultResponse;
  }
  const code = error.response?.status;
  const errorCode = errorMap[code as ErrorKey] ?? errorMap.DEFAULT;
  if (!code) {
    return defaultResponse;
  }
  return {
    errorCode: errorCode,
    status: code,
  };
}
